<template>
  <mdb-container class="gp-has-header" v-if="loggedIn">
    <mdb-card class="mb-4">
      <mdb-card-header class="primary-color text-white">
        <h4>Blocked Users</h4>
      </mdb-card-header>
      <mdb-card-body class="text-left">
        <div class="text-left" v-if="blocks.length == 0">
          You don't currently have any other users blocked from contacting you.
        </div>
        <mdb-input @input="isTyping = true"
                   @keydown.native="handleKeyDown"
                   placeholder="Lookup User to Block" type="text" v-model="query"
        />
        <mdb-row v-if="foundUsers.length>0">
          <mdb-col col="12">
            <h6>Select One:</h6>

            <span :class="{'mb-4': true, clickable: true}" :key="u.id" @click="pickUser(u)" v-for="(u,i) in foundUsers">
            <mdb-chip :color="i==selectIndex ? 'success-color' : '' " :src="u.profilePic"
                      :text="i==selectIndex ? 'white' : ''"
                      size="sm" waves>{{u.name}}</mdb-chip>
          </span>
          </mdb-col>

        </mdb-row>
      </mdb-card-body>
    </mdb-card>
    <mdb-row v-if="blocks.length>0">
      <div :key="i" class="col-md-3 d-flex align-self-stretch text-center" v-for="(b,i) in blocks">
          <mdb-card class="face front mb-4 animated slideInRight">
            <mdb-card-header class="primary-color text-white">
              {{b.name}}
            </mdb-card-header>

            <mdb-card-body>
              <avatar :avatar="b.avatar" container-class=""/>
              <mdb-btn @click="unblock(b)" icon="circle-times" rounded size="sm">Remove Block</mdb-btn>
            </mdb-card-body>
          </mdb-card>
      </div>
    </mdb-row>
  </mdb-container>

</template>
<script>
  import api from '../../services/groupsPlaceApi.js'
  import Avatar from "../common/Avatar";
  import {
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbChip,
    mdbCol,
    mdbContainer,
    mdbIcon,
    mdbInput,
    mdbRow
  } from 'mdbvue';

  export default {
    name: "user-blocks",
    display: "User Blocks",
    order: 1,
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbRow,
      mdbCol,
      mdbChip,
      Avatar
    },
    computed: {
      loggedIn() {
        return this.$store.state.loggedIn
      },
      userDetails() {
        return this.$store.state.userDetails
      },
    },
    data() {
      return {
        blocks: [],
        isTyping: false,
        foundUsers: [],
        query: "",
        selectIndex: 0

      }
    },
    mounted() {
      document.title = "Blocked Users"
      this.$store.dispatch("setExecuting", true)
      api.get("/user/blocks").then(
        (results) => {
          this.blocks = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    watch: {
      query: _.debounce(function () {
        this.isTyping = false;
      }, 300),
      isTyping: function (value) {
        if (!value) {
          if (this.query) this.lookupUser()
        }
      },
    },
    methods: {
      pickUser(u) {
        this.$store.dispatch("setExecuting", true)
        api.post("/user/blocks/" + u.id,{}).then(
          (results) => {
            this.blocks.push(results.data)
            this.foundUsers = []
            this.selectIndex = -1
            this.query = ""
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})

          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      unblock(u) {
        this.$store.dispatch("setExecuting", true)
        api.delete("/user/blocks/" + u.id).then(
          (results) => {
            let loc = this.blocks.indexOf(u)
            this.blocks.splice(loc,1)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      lookupUser() {
        this.foundUsers = []
        if (!this.query) {
          return
        }
        api.get("/conversation/findUser?term=" + this.query).then(
          (results) => {
            for (let i = 0; i < results.data.length; i++) {
              this.foundUsers = results.data
              this.selectIndex = 0
            }
          },
          (error) => {

          })
      },
      handleKeyDown(e) {
        if (this.foundUsers.length == 0) return
        let watchKeys = [37, 40, 39, 38, 13]
        if (watchKeys.indexOf(e.keyCode) === -1) return
        if (e.keyCode == 40 || e.keyCode == 39) { /*down or right*/
          this.selectIndex++
          if (this.selectIndex > (this.foundUsers.length - 1)) this.selectIndex = 0
        }
        if (e.keyCode == 38 || e.keyCode == 37) { /*up or left*/
          this.selectIndex--
          if (this.selectIndex < 0) this.selectIndex = this.foundUsers.length - 1
        }
        if (e.keyCode == 13) this.pickUser(this.foundUsers[this.selectIndex])
      }
    }

  };
</script>

<style lang='scss'>
  .stripe-card {
    width: 300px;
    border: 1px solid grey;
  }

  .stripe-card.complete {
    border-color: green;
  }
</style>
